import { useQuery } from "@tanstack/react-query";
import { mvpApiGetPlanogramOptions } from "@labeling-tools/api/atlas/@tanstack/react-query.gen";

export interface UseAtlasPlanogramOptions {
  /**
   * Lets a caller hold off firing the request even once an id is known — e.g.
   * Coverage Beta defers all planogram fetches (and the pack-shot image
   * downloads they trigger downstream) until the query image has painted, so
   * they don't compete with it for bandwidth. Defaults to true so existing
   * callers are unaffected.
   */
  enabled?: boolean;
}

export function useAtlasPlanogram(
  planogramId: string | null | undefined,
  options?: UseAtlasPlanogramOptions,
) {
  return useQuery({
    ...mvpApiGetPlanogramOptions({
      path: { planogram_id: planogramId || "" },
    }),
    enabled: !!planogramId && (options?.enabled ?? true),
    staleTime: 30_000,
  });
}
